import { SEEN_HEALTH_SYSTEM } from '#src/codeSystems.ts'

export const AI_SKILL_OWNER_TAG_SYSTEM = `${SEEN_HEALTH_SYSTEM}/CodeSystem/ai-skill-owner`
